import styled from "styled-components";
import {
  border,
  brand,
  radius,
  spacing,
  surface,
  text,
  typography,
} from "../../theme/tokens";

export const ViewerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-height: 0;
  background: ${surface.page};
`;

export const ViewerScroll = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${spacing[2]};
  padding: ${spacing[2]};
  box-sizing: border-box;

  /* react-pdf page canvases: never wider than the viewport. */
  .react-pdf__Page {
    max-width: 100%;
    box-shadow: 0 1px 4px rgba(27, 32, 40, 0.14);
    border-radius: ${radius.sm};
    overflow: hidden;
    background: #fff;
  }

  .react-pdf__Page canvas {
    max-width: 100%;
    height: auto !important;
  }
`;

export const ViewerStatus = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${spacing[2]};
  padding: ${spacing[8]} ${spacing[5]};
  text-align: center;
  color: ${text.tertiary};
  font-size: ${typography.size.md};
`;

export const ViewerStatusTitle = styled.div`
  font-weight: ${typography.weight.semibold};
  color: ${text.secondary};
`;

export const ViewerStatusDescription = styled.div`
  font-size: ${typography.size.sm};
  color: ${text.muted};
  max-width: 280px;
  line-height: 1.5;
`;

export const ViewerActionButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: ${spacing[1.5]};
  padding: ${spacing[2]} ${spacing[4]};
  border-radius: ${radius.md};
  border: 1px solid ${border.default};
  background: ${surface.surface};
  color: ${brand.primary};
  font-size: ${typography.size.sm};
  font-weight: ${typography.weight.semibold};
  cursor: pointer;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const LoadMorePagesButton = styled(ViewerActionButton)`
  margin: ${spacing[2]} 0 ${spacing[4]};
`;

export const PageCountLabel = styled.div`
  font-size: ${typography.size.xs};
  color: ${text.muted};
  font-variant-numeric: tabular-nums;
  padding: ${spacing[1]} 0;
`;

export const DocxContainer = styled.div`
  width: 100%;
  background: #fff;
  border-radius: ${radius.sm};
  overflow-x: auto;

  /* docx-preview renders a fixed-width "page"; let it scroll
     horizontally rather than blowing out the layout. */
  .docx-wrapper {
    background: transparent !important;
    padding: ${spacing[2]} !important;
  }

  .docx-wrapper section.docx {
    box-shadow: none !important;
    margin-bottom: ${spacing[2]} !important;
    max-width: 100%;
  }
`;

export const ImagePreview = styled.img`
  max-width: 100%;
  height: auto;
  border-radius: ${radius.sm};
  box-shadow: 0 1px 4px rgba(27, 32, 40, 0.14);
`;
